import { Link } from "react-router-dom";
import { get, type PublicUser } from "../services/api";
import { useAsync } from "../hooks";
import { Avatar, ErrorBox } from "./Ui";
import { Icon } from "./Icon";

export function CommunityAside() {
  const people = useAsync(
    () => get<{ items: PublicUser[] }>("/users?perPage=3"),
    [],
  );
  return (
    <aside className="community-aside">
      <section className="local-invitation">
        <Icon name="monitor" />
        <h2>
          Knowledge starts
          <br />
          on your computer.
        </h2>
        <p>
          Build your wiki locally. Share what you choose. Find the people
          thinking alongside you.
        </p>
        <Link className="btn primary" to="/download">
          <Icon name="download" />
          Download Athenaeum
        </Link>
        <Link className="text-link" to="/explore/guide">
          Read the documentation <Icon name="arrow" />
        </Link>
      </section>
      <section className="community-people">
        <div className="section-heading">
          <h2>People to explore</h2>
          <Link to="/explore/people">View all</Link>
        </div>
        {people.error ? (
          <ErrorBox error={people.error} retry={people.reload} />
        ) : (
          people.data?.items.map((person) => (
            <Link
              className="person-summary"
              key={person.username}
              to={`/user/${person.username}`}
            >
              <Avatar name={person.displayName || person.username} />
              <span>
                <strong>{person.displayName || person.username}</strong>
                <small>@{person.username}</small>
              </span>
              <Icon name="chevronRight" />
            </Link>
          ))
        )}
      </section>
      <p className="community-footnote">
        Local knowledge. Shared perspectives.
      </p>
    </aside>
  );
}
